import { render, staticRenderFns } from "./ProcedureShareThanks.vue?vue&type=template&id=8b2a5eca&"
import script from "./ProcedureShareThanks.vue?vue&type=script&lang=ts&"
export * from "./ProcedureShareThanks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports